import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../slices/authSlice';
import languageSlice from '../slices/languageSlice';
import navigationSlice from '../slices/navigationSlice';
import superheatSlice from '../slices/superheatSlice';
import errorSlice from '../slices/errorSlice';

export default configureStore({
  reducer: {
    auth: authSlice,
    language: languageSlice,
    navigation: navigationSlice,
    superheat: superheatSlice,
    error: errorSlice,
  },
});
